import { useReactiveVar } from "@apollo/client";
import { Icon } from "@dmm-com/rocket-web-ui-library";
import { memo, forwardRef } from "react";
import type { ForwardedRef } from "react";
import * as Styled from "./style";
import { NextLink } from "~/components/blocks/common/next-link";
import { ICONS, LINKS } from "~/components/blocks/layout/footer-block/const";
import { dmmServiceListDataVar } from "~/components/blocks/layout/store";
import { isBot } from "~/util/is-bot";

export const FooterBlock = memo(
  forwardRef((_, ref: ForwardedRef<HTMLDivElement>) => {
    const dmmServiceListData = useReactiveVar(dmmServiceListDataVar);
    const element = (
      <Styled.Footer ref={ref}>
        <Styled.NavIconLink>
          {ICONS.map(({ href, iconName }) => (
            <Styled.AnchorIconLink key={iconName} href={href} target="_blank" rel="noopener noreferrer">
              <Icon name={iconName} size="XL" />
            </Styled.AnchorIconLink>
          ))}
        </Styled.NavIconLink>

        <Styled.NavLinkWrapper>
          <Styled.UlNavList>
            {LINKS.map(({ href, text, target }) => (
              <Styled.LiNavItem key={text}>
                {target === "_blank" ? (
                  <a href={href} target={target} rel="noopener noreferrer">
                    {text}
                  </a>
                ) : (
                  <NextLink href={href}>{text}</NextLink>
                )}
              </Styled.LiNavItem>
            ))}
          </Styled.UlNavList>
        </Styled.NavLinkWrapper>

        <Styled.ParCopyright>Copyright &copy; since 1998 DMM All Rights Reserved.</Styled.ParCopyright>
      </Styled.Footer>
    );

    if (isBot()) return element;

    return dmmServiceListData.length !== 0 ? <>{element}</> : null;
  })
);

FooterBlock.displayName = "FooterBlock";
